import type { BaseModelAttributes } from './base';
import { I18nLabels } from './common';
import { TaskStatus, TaskStatusLabels } from './taskStatus';
import { Locale } from './locale';

// === 数字人训练状态（复用统一 TaskStatus） ===
export type AvatarTrainStatus = TaskStatus;
export const AvatarTrainStatus = TaskStatus;

export const AvatarTrainStatusLabels: I18nLabels<AvatarTrainStatus> = {
  ...TaskStatusLabels,
  [TaskStatus.PROCESSING]: { [Locale.ZH_CN]: '训练中', [Locale.EN_US]: 'Training' },
};

// === 数字人训练接口 ===
export interface IAvatarTrain extends BaseModelAttributes {
  name: string;
  videoUrl: string;
  gender: string;
  status: AvatarTrainStatus;
  modelId: string;
  externalTaskId?: string;
  avatarId?: string;
  previewUrl?: string;
  resultMessage?: string;
  /** 训练时使用的 API Key ID，用于后续视频生成时绑定同一密钥 */
  trainedWithKeyId?: string;
  submittedAt: Date;
  userId: string;
  user?: { id: string; name: string; email: string };
}

export interface CreateAvatarTrainRequest {
  name: string;
  videoUrl: string;
  gender?: string;
  modelId: string;
  videoBackgroundColor?: string;
  videoBackgroundImage?: string;
  skipPreview?: boolean;
}

export interface AvatarTrainQuery {
  search?: string;
  userId?: string;
  status?: AvatarTrainStatus;
}

// === 数字人视频状态（复用统一 TaskStatus） ===
export type AvatarVideoStatus = TaskStatus;
export const AvatarVideoStatus = TaskStatus;

export const AvatarVideoStatusLabels: I18nLabels<AvatarVideoStatus> = {
  ...TaskStatusLabels,
  [TaskStatus.PROCESSING]: { [Locale.ZH_CN]: '生成中', [Locale.EN_US]: 'Generating' },
};

// === 数字人视频接口 ===
export interface IAvatarVideo extends BaseModelAttributes {
  title?: string;
  avatarId: string;
  avatarType: number;
  audioUrl: string;
  status: AvatarVideoStatus;
  modelId: string;
  externalTaskId?: string;
  resultVideoUrl?: string;
  resultMessage?: string;
  resolution?: number;
  submittedAt: Date;
  userId: string;
  avatarTrainId?: string;
  user?: { id: string; name: string; email: string };
}

export interface CreateAvatarVideoRequest {
  avatarId: string;
  avatarType: number;
  audioUrl: string;
  title?: string;
  modelId: string;
  resolution?: number;
  avatarTrainId?: string;
  anchorBackgroundColor?: string;
  anchorBackgroundImg?: string;
  webBgWidth?: number;
  webBgHeight?: number;
  webPeopleWidth?: number;
  webPeopleHeight?: number;
  webPeopleX?: number;
  webPeopleY?: number;
}

export interface AvatarVideoQuery {
  search?: string;
  userId?: string;
  status?: AvatarVideoStatus;
}
